export enum Reactions
{
    Like = 1,
    Celebrate = 2,
    Love = 3,
    Insightful = 4,
    Curious = 5
}
